module.exports = __webpack_public_path__ + "static/media/transfer.d9ada458.png";